import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import { SparkLineChart } from "@mui/x-charts/SparkLineChart";

export default function BasicSparkLine() {
  return (
    <Stack width="50%" direction="row" gap={2}>
      <Box flexGrow={1}>
        <SparkLineChart
          plotType="bar"
          data={[1, 4, 2, 5, 7, 2, 4, 6]}
          height={50}
        />
      </Box>
    </Stack>
  );
}
